// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsConditionRouteImport } from './routes/terms-condition'
import { Route as SearchRouteImport } from './routes/search'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PostSlugRouteImport } from './routes/post.$slug'
import { Route as CategoryCategoryRouteImport } from './routes/category.$category'

const TermsConditionRoute = TermsConditionRouteImport.update({
            id: '/terms-condition',path: '/terms-condition',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ContactUsRoute = ContactUsRouteImport.update({
            id: '/contact-us',path: '/contact-us',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PostSlugRoute = PostSlugRouteImport.update({
            id: '/post/$slug',path: '/post/$slug',getParentRoute: () => rootRouteImport
          })
const CategoryCategoryRoute = CategoryCategoryRouteImport.update({
            id: '/category/$category',path: '/category/$category',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutUsRoute: AboutUsRoute,ContactUsRoute: ContactUsRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,SearchRoute: SearchRoute,TermsConditionRoute: TermsConditionRoute,CategoryCategoryRoute: CategoryCategoryRoute,PostSlugRoute: PostSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)